function App() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <h1 className="text-4xl font-bold text-gray-900">
        Battery Activator
      </h1>
    </div>
  )
}

export default App
